var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-footer',{attrs:{"app":"","color":"bal-gray"}},[_c('span',[_vm._v("Tootja.ee")]),_c('v-spacer'),_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear()))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }